import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "../../constant/baseurl";
import { apiCall } from "../../api/index";
import { showLoading } from "../slice/loadingSlice";

const createAccountAsyncThunk = (method, type, contentType, url) =>
  createAsyncThunk(type, async (payload, thunkAPI) => {
    const { data } = payload;
    const { dispatch } = thunkAPI;
    const token = localStorage.getItem("token");
    const apiRequest = {
      method: method,
      headers: token
        ? {
            "Content-Type": contentType,
            Authorization: "Token " + localStorage.getItem("token"),
          }
        : { "Content-Type": contentType },
      url: `${baseUrl}${url}`,
      data,
    };

    try {
      dispatch(showLoading.actions.toggleLoading(true));
      const res = await apiCall(apiRequest, dispatch);
      const response = res.data;

      dispatch(showLoading.actions.toggleLoading(false));

      if (response.statusFlag === true) {
        // console.log(`login action ------ ${type}`, response);
        return response;
      } else {
        // console.error(`account action - ${type}`, response);

        // Check if there is an error code in the response
        const errorCode = response.message;

        // You can throw a custom error with the error code
        throw new Error(errorCode);
      }
    } catch (error) {
      dispatch(showLoading.actions.toggleLoading(false));
      throw error;
    }
  });

export const adminCandidateList = createAccountAsyncThunk(
  "post",
  "adminCandidateList",
  "application/json",
  "valiantinfo_admin/admin_dashboard_service/admin_candidate_list/"
);

export const adminCandidateReportSummary = createAccountAsyncThunk(
  "post",
  "adminCandidateReportSummary",
  "application/json",
  "valiantinfo_admin/Candidate_report/candidate_report_summary/"
);

export const adminCandidateReportDetails = createAccountAsyncThunk(
  "post",
  "adminCandidateReportDetails",
  "application/json",
  "valiantinfo_admin/Candidate_report/candidate_report_details/"
);

export const CandidateFinalConclusion = createAccountAsyncThunk(
  "post",
  "CandidateFinalConclusion",
  "application/json",
  "valiantinfo_admin/manual_documents/complete_status_update/"
);

export const CandidateTechFinalConclusion = createAccountAsyncThunk(
  "post",
  "CandidateTechFinalConclusion",
  "application/json",
  "valiantinfo_admin/admin_settings/completed_by_tech/"
);

export const adminLogin = createAccountAsyncThunk(
  "post",
  "adminLogin",
  "application/json",
  "valiantinfo_admin/admin_login_logout_service/admin_verifier_login/"
);

export const adminLogout = createAccountAsyncThunk(
  "post",
  "adminLogout",
  "application/json",
  "valiantinfo_admin/admin_login_logout_service/logout/"
);

export const fetchCheckDetails = createAccountAsyncThunk(
  "post",
  "fetchCheckDetails",
  "application/json",
  "valiantinfo_admin/admin_dashboard_service/candidate_get_each_checkdetails/"
);


export const manualCourtCheck = createAccountAsyncThunk(
  "post",
  "manualCourtCheck",
  "application/json",
  "valiantinfo_admin/manual_documents/add_manual_court_documents/"
);


export const JobSeeekerIdChange = createAccountAsyncThunk(
  "post",
  "JobSeeekerIdChange",
  "application/json",
  "valiantinfo_admin/manual_documents/update_job_seeker_id/"
);

export const PendingChecksReport = createAccountAsyncThunk(
  "get",
  "PendingChecksReport",
  "application/json",
  "valiantinfo_admin/manual_documents/get_pending_check_details/"
);

export const GetNotificationRecipients = createAccountAsyncThunk(
  "get",
  "GetNotificationRecipients",
  "application/json",
  "valiantinfo_admin/admin_dashboard_service/notification_recipients/"
);

export const SendNoticeEmail = createAccountAsyncThunk(
  "post",
  "SendNoticeEmail",
  "application/json",
  "valiantinfo_admin/admin_dashboard_service/send_notice_email/"
);

export const ManualWork = createAccountAsyncThunk(
  "post",
  "ManualWork",
  "application/json",
  "valiantinfo_admin/reopen_case_service/manual_work/"
);

export const CandidateUpdateChecks = createAccountAsyncThunk(
  "post",
  "CandidateUpdateChecks",
  "application/json",
  "valiantinfo_admin/reopen_case_service/CandidateChecks/"
);

export const FetchCheckFields = createAccountAsyncThunk(
  "post",
  "FetchCheckFields",
  "application/json",
  "valiantinfo_admin/reopen_case_service/fetch_checks_field/"
);

export const manualOFACCheck = createAccountAsyncThunk(
  "post",
  "manualOFACCheck",
  "application/json",
  "valiantinfo_admin/manual_documents/ofac_check/"
);

export const manualForm26ASCheck = createAccountAsyncThunk(
  "post",
  "manualForm26ASCheck",
  "application/json",
  "valiantinfo_admin/manual_documents/form26_check/"
);

export const manualForm16Check = createAccountAsyncThunk(
  "post",
  "manualForm16Check",
  "application/json",
  "valiantinfo_admin/manual_documents/form16_check/"
);

export const manualBankVerificationCheck = createAccountAsyncThunk(
  "post",
  "manualBankVerificationCheck",
  "application/json",
  "valiantinfo_admin/manual_documents/bankverification_check/"
);


export const manualSalaryVerificationCheck = createAccountAsyncThunk(
  "post",
  "manualSalaryVerificationCheck",
  "application/json",
  "valiantinfo_admin/manual_documents/salaryverification_check/"
);


export const UpdateResumeUrl = createAccountAsyncThunk(
  "post",
  "UpdateResumeUrl",
  "multipart/form-data",
  "valiantinfo_admin/manual_documents/update_resume_url/"
);

export const ManualDocumentsGenerateUrl = createAccountAsyncThunk(
  "post",
  "ManualDocumentsGenerateUrl",
  "multipart/form-data",
  "valiantinfo_admin/admin_settings/generate_url/"
);

export const ManualDocumentsFetchUrl = createAccountAsyncThunk(
  "post",
  "ManualDocumentsGenerateUrl",
  "application/json",
  "valiantinfo_admin/admin_settings/fetch_s3_url/"
);

// export const manualSalaryVerificationCheck = createAccountAsyncThunk(
//   "post",
//   "manualSalaryVerificationCheck",
//   "application/json",
//   "valiantinfo_admin/manual_documents/salaryverification_check/"
// );

export const GenerateDailyClientReport = createAccountAsyncThunk(
  "post",
  "GenerateDailyClientReport",
  "application/json",
  "valiantinfo_admin/report_service/generate_client_daily_report/"
);

export const GenerateDailyVendorReport = createAccountAsyncThunk(
  "post",
  "GenerateDailyVendorReport",
  "application/json",
  "valiantinfo_admin/report_service/generate_vendor_daily_report/"
);

export const GenerateCandidateStatusCancelReport = createAccountAsyncThunk(
  "post",
  "GenerateCandidateStatusCancelReport",
  "application/json",
  "valiantinfo_admin/candidate_daily_status_checker/candidate_status_cancel/"
);

export const AdminInvoiceGeneration = createAccountAsyncThunk(
  "post",
  "AdminInvoiceGeneration",
  "application/json",
  "valiantinfo_admin/admin_invoice_generation/invoice_generation/"
);

export const UpdateCandidateAddress = createAccountAsyncThunk(
  "post",
  "UpdateCandidateAddress",
  "multipart/form-data",
  "valiantinfo_admin/manual_documents/update_address/"
);

export const UpdateCandidatePersonalInfo = createAccountAsyncThunk(
  "post",
  "UpdateCandidatePersonalInfo",
  "multipart/form-data",
  "valiantinfo_admin/manual_documents/update_personal_info/"
);

export const ClosedInsufficiencyComments = createAccountAsyncThunk(
  "post",
  "ClosedInsufficiencyComments",
  "multipart/form-data",
  "valiantinfo_admin/InsufficientComments/closed_insufficiency_comments/"
);

export const GetCreateUserOptions = createAccountAsyncThunk(
  "get",
  "GetCreateUserOptions",
  "application/json",
  "valiantinfo_admin/admin_login_logout_service/dashboard-get/"
);

export const CreateAdminVerifierFinance = createAccountAsyncThunk(
  "post",
  "CreateAdminVerifierFinance",
  "application/json",
  "valiantinfo_admin/admin_login_logout_service/create_admin_verifier_finance/"
);

export const CreateMaster = createAccountAsyncThunk(
  "post",
  "CreateMaster",
  "application/json",
  "valiantinfo_admin/admin_login_logout_service/MasterAPI/"
);

export const GetVerifierCompletedChecks = createAccountAsyncThunk(
  "post",
  "GetVerifierCompletedChecks",
  "application/json",
  "valiantinfo_admin/admin_login_logout_service/verifier_completed_checks/"
);

